"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var Yup = _interopRequireWildcard(require("yup"));

var _dist = require("@low6dev/react-utils/dist");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var _default = function _default(t, hidePostcode, hideLine1, hideCity) {
  var schema = {
    firstName: Yup.string().min(2, (0, _dist.minError)(t.firstName, 2, t.minError, t.characters)).max(50, (0, _dist.maxError)(t.firstName, 50, t.maxError, t.characters)).required((0, _dist.requiredError)(t.firstName, t.isRequiredError)),
    lastName: Yup.string().min(2, (0, _dist.minError)(t.lastName, 2, t.minError, t.characters)).max(50, (0, _dist.maxError)(t.lastName, 50, t.maxError, t.characters)).required((0, _dist.requiredError)(t.lastName, t.isRequiredError)),
    mobileNumber: Yup.string().required((0, _dist.requiredError)(t.mobileNumber, t.isRequiredError)).min(10, (0, _dist.minError)(t.mobileNumber, 10, t.minError, t.characters)).max(16, (0, _dist.maxError)(t.mobileNumber, 16, t.maxError, t.characters)).nullable()
  };

  if (!hidePostcode) {
    schema.postcode = Yup.string().min(3, (0, _dist.minError)(t.postcode, 3, t.minError, t.characters)).max(7, (0, _dist.maxError)(t.postcode, 7, t.maxError, t.characters)).required((0, _dist.requiredError)(t.postcode, t.isRequiredError)).test("regexp", t.postcodeValidityError, function (value) {
      return /^[A-Za-z0-9\s]*$/.test(value);
    });
  }

  if (!hideCity) {
    schema.city = Yup.string().min(2, (0, _dist.minError)(t.city, 2, t.minError, t.characters)).max(50, (0, _dist.maxError)(t.city, 50, t.maxError, t.characters)).required((0, _dist.requiredError)(t.city, t.isRequiredError));
  }

  if (!hideLine1) {
    schema.line_1 = Yup.string().min(2, (0, _dist.minError)(t.addressLine, 2, t.minError, t.characters)).max(50, (0, _dist.maxError)(t.addressLine, 50, t.maxError, t.characters)).required((0, _dist.requiredError)(t.addressLine, t.isRequiredError));
  }

  return Yup.object().shape(schema);
};

exports.default = _default;